import {
  INIT_CATEGORY,
  INIT_GALLERY,
  CLICK_CATEGORY,
  CLICK_PAGER,
} from "@/shared/components/photo_gallery/constants/action_types";

// 初期値
const initialState = {
  photos: [],
  filteredPhotos: [],
  categoryId: null,
  accentColor: "",
  page: 1,
};

// フォトをカテゴリで絞り込む
const filterPhotos = (photos, categoryId) => {
  let filteredPhotos = [];
  if (categoryId) {
    filteredPhotos = photos.filter((photo) => {
      return photo.photo_gallery_category_id == categoryId;
    });
  } else {
    filteredPhotos = photos;
  }

  return filteredPhotos;
};

// Action の種別によってステータスを更新
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_CATEGORY: {
      return { ...state, categoryId: action.payload.categoryId };
    }
    case INIT_GALLERY: {
      return {
        ...state,
        photos: action.payload.photos,
        filteredPhotos: filterPhotos(action.payload.photos, state.categoryId),
        accentColor: action.payload.accentColor,
      };
    }
    case CLICK_CATEGORY: {
      return {
        ...state,
        filteredPhotos: filterPhotos(state.photos, action.payload.categoryId),
        categoryId: action.payload.categoryId,
        page: 1,
      };
    }
    case CLICK_PAGER: {
      return { ...state, page: action.payload.page };
    }
    default: {
      return state;
    }
  }
};
